/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Keep_FocusInputs */

const en_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep focusing`)
};

const ar_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واصل التركيز`)
};

const de_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter konzentrieren`)
};

const es_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue concentrándote`)
};

const fr_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rester concentré`)
};

const it_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a concentrarti`)
};

const ja_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中を続ける`)
};

const ko_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속 집중하기`)
};

const pt_br_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar mantendo o foco`)
};

const ru_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить фокусироваться`)
};

const th_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสต่อไป`)
};

const tr_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmaya devam et`)
};

const zh_cn_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续专心`)
};

const zh_tw_btn_keep_focus = /** @type {(inputs: Btn_Keep_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續專心`)
};

/**
* | output |
* | --- |
* | "Keep focusing" |
*
* @param {Btn_Keep_FocusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_keep_focus = /** @type {((inputs?: Btn_Keep_FocusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Keep_FocusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_keep_focus(inputs)
	if (locale === "ar") return ar_btn_keep_focus(inputs)
	if (locale === "de") return de_btn_keep_focus(inputs)
	if (locale === "es") return es_btn_keep_focus(inputs)
	if (locale === "fr") return fr_btn_keep_focus(inputs)
	if (locale === "it") return it_btn_keep_focus(inputs)
	if (locale === "ja") return ja_btn_keep_focus(inputs)
	if (locale === "ko") return ko_btn_keep_focus(inputs)
	if (locale === "pt_br") return pt_br_btn_keep_focus(inputs)
	if (locale === "ru") return ru_btn_keep_focus(inputs)
	if (locale === "th") return th_btn_keep_focus(inputs)
	if (locale === "tr") return tr_btn_keep_focus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_keep_focus(inputs)
	return zh_tw_btn_keep_focus(inputs)
});